import { map, Observable, OperatorFunction } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CustomHttpClient } from '@infra/http/custom-http-client';

export abstract class BaseRepository {
  constructor(
    httpClient: HttpClient,
    serverUrl: string,
    baseRoute: string,
    ignoreInterceptor: boolean = false
  ) {
    this.basePath = baseRoute;
    this.customClient = new CustomHttpClient(httpClient, serverUrl, ignoreInterceptor);
  }
  public customClient: CustomHttpClient;
  public basePath: string;

  public getByIdRequest<T>(id: any, headers?: any | HttpHeaders): Observable<T> {
    return this.customClient.get<T>(`${this.basePath}/${id}`, undefined, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  public getRequest<T>(
    params?: any | HttpParams | HttpParams,
    headers?: any | HttpHeaders
  ): Observable<T> {
    return this.customClient.get<T>(this.basePath, params, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  public postRequest<T>(body?: any, headers?: any | HttpHeaders): Observable<T> {
    return this.customClient.post<T>(this.basePath, body, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  public putRequest<T>(id?: any, body?: any, headers?: any | HttpHeaders): Observable<T> {
    return this.customClient.put<T>(`${this.basePath}/${id}`, body, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  public patchRequest<T>(id?: any, body?: any, headers?: any | HttpHeaders): Observable<T> {
    return this.customClient.patch<T>(`${this.basePath}/${id}`, body, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  public deleteRequest<T>(id?: any, headers?: any | HttpHeaders): Observable<T> {
    return this.customClient.delete<T>(`${this.basePath}/${id}`, headers).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
  protected handleResponseRequest(data: any) {
    console.error(`Request error response ${JSON.stringify(data)}`);
    throw new Error(`Request error response invalid`);
  }
  protected mapperData(): OperatorFunction<any, any> {
    return map((data: any) => {
      if (!data) this.handleResponseRequest(data);
      if (!data.data) return data;
      return data.data;
    });
  }
}
